'use es6';

import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import React, { useMemo, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIButton from 'UIComponents/button/UIButton';
import UISelect from 'UIComponents/input/UISelect';
import UIFormControl from 'UIComponents/form/UIFormControl';
import GoodFiltersAndPage from '../constants/GoodFiltersAndPage';
import ProviderOptions from '../constants/ProviderOptions';
import { requestStatusPropType } from '../constants/propTypes/requestStatus';
import { getArrOfTextValPairsForSelect } from '../utils/utils';
import { getProviderOptionText } from '../utils/langUtils';
import { isUninitialized, isPending, isFailed } from '../utils/requestStatus';

var ProviderDropdown = function ProviderDropdown(_ref) {
  var allProviders = _ref.allProviders,
      disableOptions = _ref.disableOptions,
      fetchProviders = _ref.fetchProviders,
      onGoodFilterChange = _ref.onGoodFilterChange,
      providerFilter = _ref.providerFilter,
      providersRequestStatus = _ref.providersRequestStatus;
  var requestUninitialized = isUninitialized(providersRequestStatus);
  var requestPending = isPending(providersRequestStatus);
  var requestFailed = isFailed(providersRequestStatus);

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      open = _useState2[0],
      setOpen = _useState2[1];

  var renderedErrorMessage = useMemo(function () {
    return requestFailed && React.createElement(FormattedJSXMessage, {
      message: "sidebar.providerFilter.error_jsx",
      elements: {
        Button: UIButton
      },
      options: {
        onClick: function onClick() {
          return fetchProviders();
        },
        use: 'link'
      }
    });
  }, [fetchProviders, requestFailed]);
  var options = useMemo(function () {
    return getArrOfTextValPairsForSelect([ProviderOptions.ALL].concat(_toConsumableArray(allProviders)), getProviderOptionText).map(function (option) {
      return Object.assign({}, option, {
        disabled: disableOptions
      });
    });
  }, [allProviders, disableOptions]);
  useEffect(function () {
    if (open && requestUninitialized) {
      fetchProviders();
    }
  }, [fetchProviders, open, requestUninitialized]);
  return React.createElement(UIFormControl, {
    label: React.createElement(FormattedMessage, {
      message: "sidebar.providerFilter.title"
    }),
    validationMessage: renderedErrorMessage,
    verticalSeparation: "flush"
  }, React.createElement(UISelect, {
    anchorType: "button",
    className: "p-x-0 p-top-0",
    buttonUse: "transparent",
    "data-test-id": "provider-dropdown",
    isLoading: requestPending,
    menuWidth: 250,
    minimumSearchCount: 0,
    onChange: function onChange(evt) {
      return onGoodFilterChange(_defineProperty({}, GoodFiltersAndPage.PROVIDER, evt.target.value));
    },
    onOpenChange: function onOpenChange(evt) {
      return setOpen(evt.target.value);
    },
    open: open,
    options: options,
    placement: "bottom right",
    searchable: true,
    value: getProviderOptionText(providerFilter)
  }));
};

ProviderDropdown.propTypes = {
  allProviders: PropTypes.array.isRequired,
  disableOptions: PropTypes.bool.isRequired,
  fetchProviders: PropTypes.func.isRequired,
  onGoodFilterChange: PropTypes.func.isRequired,
  providerFilter: PropTypes.string.isRequired,
  providersRequestStatus: requestStatusPropType.isRequired
};
ProviderDropdown.defaultProps = {
  disableOptions: false
};
export default ProviderDropdown;